/** A source action must never execute a script or silently reload the Board. */
export function alertSourceUrl(value: string | null | undefined): string | null {
  if (!value?.trim()) return null;
  try {
    const url = new URL(value.trim());
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}

export function boardGreetingName(value: string): string {
  // Preserve the preferred name, including honorifics and multi-part names.
  return value.trim();
}
